package com.example.mystybag.common.extensions

import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.drawscope.ContentDrawScope
import androidx.compose.ui.node.CompositionLocalConsumerModifierNode
import androidx.compose.ui.node.DrawModifierNode
import androidx.compose.ui.node.ModifierNodeElement
import androidx.compose.ui.node.currentValueOf
import com.example.mystybag.core.views.AppTheme

private class SurfaceBackgroundNode(var color: Color?): Modifier.Node(), DrawModifierNode, CompositionLocalConsumerModifierNode {

    override fun ContentDrawScope.draw() {
        drawRect(
            color = color ?: currentValueOf(AppTheme).colors.surface
        )
        drawContent()
    }
}

private data class SurfaceBackgroundElement(val color: Color?): ModifierNodeElement<SurfaceBackgroundNode>() {
    override fun create(): SurfaceBackgroundNode = SurfaceBackgroundNode(color)
    override fun update(node: SurfaceBackgroundNode) {
        node.color = color
    }
}

fun Modifier.surfaceBackground(color: Color? = null) = this.then(SurfaceBackgroundElement(color))